// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CustomTitle{\n  line-height:1.5 !important\n}\n@media (min-width: 1280px){\n.CustomTitle{\n    line-height:4.5rem !important\n}\n}\n.fade-enter-active,.fade-leave-active{\n  transition:opacity 2s ease-in-out\n}\n.fade-enter,.fade-leave-to{\n  opacity:0\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
